import React from "react";


    const decorationServices = [
        {
            icon:"💍",
            title:"Wedding Decoration",
            desc:"Elegant wedding stages, mandap designs and luxury wedding setups."
        },
        {
            icon:"🌸",
            title:"Floral Decoration",
            desc:"Beautiful flower arrangements and premium floral concepts."
        },
        {
            icon:"🎭",
            title:"Theme Decoration",
            desc:"Creative themes designed according to your event vision."
        },
        {
            icon:"🏢",
            title:"Corporate Events",
            desc:"Professional decoration for conferences and business events."
        },
        {
            icon:"🎂",
            title:"Birthday Decoration",
            desc:"Customized birthday and celebration setups."
        },
        {
            icon:"🌿",
            title:"Outdoor Decoration",
            desc:"Farmhouse, garden and destination event decoration."
        }
    ];


    const themes = [
        {
            title:"Royal Wedding Theme",
            image:"/assets/img/banner/Royal Wedding Theme.jpg"
        },
        {
            title:"Traditional Indian Theme",
            image:"/assets/img/banner/Traditional Indian Theme.jpg"
        },
        {
            title:"Modern Luxury Theme",
            image:"/assets/img/banner/Modern Luxury Theme.jpg"
        },
        {
            title:"Floral Theme",
            image:"/assets/img/banner/Floral Theme.jpg"
        }
    ];


    const features = [
        "Creative Event Concepts",
        "Premium Quality Materials",
        "Experienced Decoration Team",
        "On-Time Setup",
        "Customized Designs",
        "Complete Event Support"
    ];
const  Decoration = () => {
  return (
    <>
      {/* Breadcrumb Section Start */}
      <div className="breadcumb-section">
        <div className="breadcumb-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="breadcumb-content">
                  <h1 className="breadcumb-title">Decoration</h1>

                  <ul className="breadcumb-menu">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li className="text-white">/</li>
                    <li className="active"> Decoration </li>
                  </ul>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    
    <div className="decoration-page">
        {/* Intro */}

        <section className="decoration-intro container">

            <div className="intro-image">
                <img 
                src="/assets/img/banner/decoration.jpg"
                alt="decoration"
                />
            </div>

            <div className="intro-content">

                <h2>
                    Creative Event Decoration That
                    Tells Your Story
                </h2>

                <p>
                    We transform ordinary spaces into
                    extraordinary celebrations with unique
                    concepts, elegant designs and perfect
                    execution.
                </p>

                <p>
                    From traditional weddings to luxury events,
                    every detail is planned beautifully to create
                    memorable experiences.
                </p>
            </div>

        </section>
        {/* Services */}

        <section className="services-section">
            <h2>
                Our Decoration Services
            </h2>

            <div className="service-grid">

            {
                decorationServices.map((item,index)=>(

                    <div className="service-card" key={index}>

                        <div className="service-icon">
                            {item.icon}
                        </div>

                        <h3 className="title">
                            {item.title}
                        </h3>

                        <p>
                            {item.desc}
                        </p>
                    </div>
                ))
            }
            </div>
        </section>
        {/* Themes */}
        <section className="theme-section">
            <h2>
                Our Decoration Styles
            </h2>
            <div className="theme-grid">
            {
                themes.map((item,index)=>(
                    <div className="theme-card" key={index}>
                        <img 
                        src={item.image}
                        alt={item.title}
                        />
                        <div>
                            <h3  className="title">
                                {item.title}
                            </h3>
                        </div>
                    </div>
                ))
            }
            </div>
        </section>

        {/* Special Setup */}
        <section className="special-section">
            <h2>
                Special Setup Services
            </h2>
            <div className="special-grid">

                <span>✨ Entrance Decoration</span>

                <span>🌺 Stage Design</span>

                <span>💡 Lighting Setup</span>

                <span>🪑 Furniture Setup</span>

                <span>🌸 Ceiling Decoration</span>

                <span>🎪 Welcome Area Setup</span>
            </div>
        </section>
    </div>
</>
    );

};

export default Decoration;
